define(['jquery', 'common'], function ($, Common) {
	var ResponsiveCountries = function() {
		var self = this;
		self.common = new Common();
		self.$ervBody = $('#erv-body');

		self.addEventListener = function () {
			self.$ervBody.find('.stack').each(function () {
				var $stackElement = $(this);
				var $list = $stackElement.find('ul');

				if ($list.find('li').length > 5) {
					$stackElement.find('.action a').removeClass('hide');
					$list.addClass('is-collapsed');

					$stackElement.find('.action a').on('click', function (e) {
						e.preventDefault();
						var $trigger = $(this);
						$list.toggleClass('is-collapsed');

						if (!$list.hasClass('is-collapsed')) {
							$list.attr('style', '');
							$trigger.find('.show-less').removeClass('hide');
							$trigger.find('.show-more').addClass('hide');
						} else {
							$trigger.find('.show-less').addClass('hide');
							$trigger.find('.show-more').removeClass('hide');
						}
					});
				}
			});
		}

		self.removeEventListener = function () {
			self.$ervBody.find('.stack ul').each(function () {
				var $list = $(this);
				$list.removeClass('is-collapsed');
				$list.parent().find('.action a').unbind();
				$list.parent().find('.action a').addClass('hide');
				$list.attr('style', '');
			});
		}
	};

	ResponsiveCountries.prototype.initSmallDevice = function () {
		var self = this;
		self.removeEventListener();
		self.addEventListener();
	}

	ResponsiveCountries.prototype.initLargerDevices = function () {
		var self = this;
		self.removeEventListener();
	}

	return ResponsiveCountries;
});